<template>
  <div>
    <div
      id="mobile-header"
      :class="{
        [$style['mobile-nav']]: true,
        'is-scrolling-down': isScrollingDownState,
        [$style['mobile-nav__drawer-ontop-of-filter']]: isOpen,
        [$style['mobile-nav__fix-mobile-filter']]: isScrollingDownState && isFixedMobileHeaderRoute,
      }"
    >
      <VAppBar
        id="app-bar"
        :height="defaultHeight"
        clipped-left
        app
        fixed
        flat
        :class="[$style.appBar, { [$style.isSupportUser]: isSupportUser }]"
      >
        <MobileMenuHeader
          :dashboard-url="dashboardUrl"
          :mobile-list="mobileList"
          :open="isOpen"
          @click="isOpen = !isOpen"
        />
      </VAppBar>
      <MobileSearchBar />
      <portal-target name="mobile-navigation-bottom-bar" />

      <v-navigation-drawer
        v-model="isOpen"
        :class="[$style['mobile-nav__drawer']]"
        fixed
        hide-overlay
        width="100%"
      >
        <div :class="$style['mobile-nav__drawer__header']">
          <div :class="$style['wrapper']" @click="isOpen = !isOpen">
            <IconSelect :class="$style['menu-icon']" icon="close" height="44" width="44" />
          </div>
          <NavigationCustomerNumber
            :class="{
              [$style['customer-number--support']]: isSupportUser,
            }"
          />
          <div :class="$style['flex']">
            <NavigationLanguageSwitch />
            <!-- <a :class="$style.logo" :href="dashboardUrl">
              <PonLogoSmall />
            </a> -->
          </div>
        </div>
        <MobileMenuItemList
          v-if="topNavigationItems"
          :items="topNavigationItems"
          @item-click="isOpen = false"
        />
      </v-navigation-drawer>
      <div
        v-show="isProductRoute"
        :class="{
          [$style['filter-wrapper']]: true,
          [$style['filter-wrapper__filter-fixed']]: isScrollingDownState && isProductRoute,
        }"
      >
        <MobileFilter :class="$style['filter-wrapper__mobile-filter']" />
        <MobileSparePartsFinder v-if="isSparePartsRoute" />
        <MobileFilterCount />
      </div>
      <div
        v-show="isServiceBasketRoute"
        :class="{
          [$style['filter-wrapper']]: true,
          [$style['filter-wrapper__filter-fixed']]: isScrollingDownState,
        }"
      >
        <portal-target name="service-basket-bar" multiple class="w-100" />
      </div>
    </div>
    <ScrollToTop />
  </div>
</template>

<script>
import { debounce, isUndefined } from 'lodash-es'
import { mapGetters, mapMutations, mapState } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import APP_GETTER from '@/js/plugins/store/modules/app/getter-types.js'
import APP_MUTATIONS from '@/js/plugins/store/modules/app/mutation-types.js'

import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'
import MobileSearchBar from '@/js/components/Search/mobile/MobileSearchBar.vue'

import MobileMenuHeader from '@/js/components/Navigation/mobile/MobileMenuHeader.vue'
import MobileMenuItemList from '@/js/components/Navigation/mobile/MobileMenuItemList.vue'
// import PonLogoSmall from '@/js/components/Shared/SvgSelect/SVG/PonLogoSmall.vue'
import NavigationLanguageSwitch from '@/js/components/Navigation/NavigationLanguageSwitch'
import NavigationCustomerNumber from '@/js/components/Navigation/NavigationCustomerNumber.vue'

import ScrollToTop from '@/js/components/Shared/ScrollToTop.vue'

import { isTouchDevice } from '@/js/helper/is-touch-device.js'
import MessageCenterLinktilesMixin from '@/js/mixins/message-center-linktiles-mixin.js'
import PermissionMixin from '@/js/mixins/permission-mixin.js'
import ScopeMixin from '@/js/mixins/scope-mixin.js'

import MobileFilter from '@/js/components/ContentElement/Catalog/mobile/MobileFilter'
import MobileFilterCount from '@/js/components/ContentElement/Catalog/mobile/MobileFilterCount'
import MobileSparePartsFinder from '@/js/components/ContentElement/Catalog/mobile/MobileSparePartsFinder'
// import { nextTick } from '@vue/composition-api'
// import fromUnixTime from 'date-fns/fp/fromUnixTime/index.js'

export default {
  name: 'MobileNavigation',
  components: {
    MobileMenuHeader,
    MobileMenuItemList,
    // PonLogoSmall,
    IconSelect,
    MobileSearchBar,
    ScrollToTop,
    NavigationLanguageSwitch,
    MobileFilter,
    MobileFilterCount,
    MobileSparePartsFinder,
    NavigationCustomerNumber,
  },
  mixins: [ScopeMixin, PermissionMixin, MessageCenterLinktilesMixin],
  props: {
    navigationItems: {
      type: Array,
      default: () => [],
    },
    isSupportUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      panel: [],
      isOpen: false,
      defaultHeight: 50,
      currentYPosition: 0,
      maxYScollPosition: 0,
      isScrollingDownState: false,
      mobileFilterOnScroll: false,
    }
  },
  computed: {
    ...mapState(STOREMODULES.APP, {
      showScrollToTop: APP_CONSTANTS.SHOW_SCROLL_TO_TOP,
    }),
    ...mapGetters(STOREMODULES.APP, {
      dashboardUrl: APP_GETTER.DASHBOARD_URL,
      appShopModus: APP_GETTER.SHOPMODUS,
    }),
    mobileList() {
      return this.navigationItems
        .filter(
          item =>
            item.attributes.component === 'NavigationSerialNumberSearch' ||
            item.attributes.component === 'FavoritesDialog' ||
            item.attributes.icon === 'complaint' ||
            (item.attributes.component === 'NavigationProductsList' &&
              item.type === 'navigation/icon_item'),
          // item.attributes.component === 'NavigationCompareList',
        )
        .map(item => ({ ...item, hideTitle: true }))
    },
    // favorites() {
    //   return this.navigationItems.filter(
    //     item => item.attributes.component.indexOf('Favorites') === 0,
    //   )
    //   // .pop()
    // },
    // serviceList() {
    //   return this.navigationItems.filter(item => item.attributes.icon.indexOf('complaint') === 0)
    //   // .pop()
    // },
    // compareList() {
    //   return this.navigationItems.filter(
    //     item => item.attributes.component.indexOf('NavigationCompareList') === 0,
    //   )
    //   // .pop()
    // },
    topNavigationItems() {
      const topNavigationItems = this.navigationItems
        .filter(item => item.attributes.component !== 'NavigationSerialNumberSearch')
        .filter(item => item.attributes.component !== 'NavigationCompareList')
        .filter(item => item.attributes.component !== 'FavoritesDialog')
        .filter(item => item.attributes.title !== 'Divider')
        // Merge custom link tiles
        .map(navigationItem => {
          if (navigationItem.attributes?.component === 'NavigationProductsList') {
            const children = this.generateProductsListLinkTiles()
            navigationItem.show = !!children.length
            if (navigationItem.show) {
              navigationItem.children = children
            }
          }
          return navigationItem
        })
        .filter(navigationItem => navigationItem.show)

      return topNavigationItems
    },
    isProductRoute() {
      return this.$route.meta.isSearchList
    },
    isSparePartsRoute() {
      return this.$route.name === 'SERVICE'
    },
    isServiceBasketRoute() {
      return this.$route.meta.isServiceBasket
    },
    isFixedMobileHeaderRoute() {
      return this.isProductRoute || this.isServiceBasketRoute
    },
  },

  watch: {
    isOpen() {
      document.querySelector('html').classList.toggle('overflow-y-hidden')
    },
    $route() {
      this.isScrollingDownState = false
    },
  },
  mounted() {
    // !TODO: remove scroll listener if possible

    window.addEventListener(
      'scroll',
      debounce(
        () => {
          const tempPosition = this.currentYPosition
          const pageYPosition = window.pageYOffset

          const showScrollToTop = isTouchDevice
            ? pageYOffset >= this.getWindowInnerHeight() * 2
            : undefined
          if (!isUndefined(showScrollToTop) && this.showScrollToTop !== showScrollToTop) {
            this.setShowScrollToTop(showScrollToTop)
          }

          const difference = Math.abs(pageYPosition - tempPosition)
          if (difference < 5) {
            return
          }

          const maxYPosition = this.getMaxYScrollPosition()

          this.currentYPosition =
            pageYPosition > maxYPosition ? maxYPosition : pageYPosition < 0 ? 0 : window.pageYOffset

          const newState =
            this.currentYPosition === maxYPosition || this.currentYPosition - tempPosition > 0
          if (newState !== this.isScrollingDownState) {
            this.isScrollingDownState = newState
            document.body.classList.toggle('is-scrolling-down', newState)
          }
        },
        25,
        {
          maxWait: 50,
          leading: true,
          trailing: false,
        },
      ),
      { passive: true },
    )

    /// MY TEST LOG CALL
    console.log({ 'CHECK CURRENT ROUTE': this.isSparePartsRoute })
  },
  methods: {
    ...mapMutations(STOREMODULES.APP, {
      setShowScrollToTop: APP_MUTATIONS.SET_SHOW_SCROLL_TO_TOP,
    }),
    getMaxYScrollPosition: debounce(
      function () {
        this.maxYScollPosition = document.body.scrollHeight - this.getWindowInnerHeight()
        return document.body.scrollHeight - this.getWindowInnerHeight()
      },
      200,
      {
        leading: true,
        trailing: false,
      },
    ),
    getWindowInnerHeight: debounce(
      function () {
        return window.innerHeight
      },
      200,
      {
        leading: true,
        trailing: false,
      },
    ),
  },
}
</script>

<style lang="scss" module>
.appBar {
  // Make Header scrollable for extra small screens
  @media screen and (max-width: 375px) {
    overflow-x: auto;
    overflow-y: hidden;
  }
}

.menu-icon {
  color: var(--black);
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.wrapper {
  display: flex;
  align-items: center;

  outline: 0 none;

  cursor: pointer;

  pointer-events: all;
}

.mobile-nav {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    display: none;
  }
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 199;

  display: block;

  width: 100% !important;
  overflow: visible;

  background-color: var(--white);

  &__drawer-ontop-of-filter {
    z-index: 999 !important;
  }

  :global(#app-bar) {
    background-color: var(--white);
  }

  &__drawer {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: var(--v-primary-base);

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.5rem 0.8rem 0 0.8rem;
    }
  }

  &__fix-mobile-filter {
    transform: translateY(-96px) !important;
  }
}

:global(.base-layout--hide-navigation) .mobile-nav {
  display: none;
}

.filter-wrapper {
  // position: fixed;
  top: 6rem;
  // z-index: 199;

  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100% !important;
  overflow: visible;

  background-color: #d5f2f9;

  // transition: 0.3s top ease-in;
  // transition-delay: 0.3s;

  &__filter-fixed {
    top: 0 !important;

    transition: all 0.3s ease-in;
    transition-delay: 0.3s;
  }

  &__mobile-filter {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      display: none;
    }
  }
}

.customer-number--support {
  padding: 5px 5px;

  color: var(--white);
  font-weight: var(--font-weight-bold);

  background: var(--red);

  svg {
    color: var(--white);
  }
}

.isSupportUser {
  background: linear-gradient(
    90deg,
    var(--red-lighten-2) 0%,
    rgba(255, 255, 255, 1) 16%,
    rgba(255, 255, 255, 1) 100%
  ) !important;
  background-color: var(--red) !important;
}
</style>
